import React from 'react';

const Template2Mentions = () => {

    return (
        <div className="row text-center">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <p className={"text-center"} style={{ 'textAlign':'center', 'fontStyle': 'italic', "fontSize":"7pt"}}>
                Pour les communes à CC ou PLU : La présente décision est transmise au représentant de l’État dans les conditions prévues à l’article L.2131-2 du code général des collectivités territoriales
            </p>
            <div className="col-12 text-center  font-weight-lighter"  style={{"textAlign":"center", "fontSize":"6pt", "color": "#7e8c8d"}}>
                <h5 style={{ 'textAlign':'center', 'marginBottom': '1px'}}>DURÉE DE VALIDITÉ</h5>
                <p style={{'textAlign':'center'}} className={'font-italic'}>
                    Conformément à l’article L 410-1 du Code de l’Urbanisme, lorsqu’une demande d’autorisation ou une déclaration préalable est déposée
                    dans un délai de dix-huit mois à compter de la délivrance du présent certificat d’urbanisme, les dispositions d’urbanisme, le régime des
                    taxes et participations d’urbanisme ainsi que les limitations administratives au droit de propriété tels qu’ils existaient à la date du présent
                    certificat ne peuvent être remises en cause à l’exception des dispositions ayant pour objet la préservation de la sécurité ou de la salubrité
                    publique.
                </p>
            </div>
            <div className="col-12 text-center  font-weight-lighter" style={{"textAlign":"center", "fontSize":"6pt", "color": "#7e8c8d"}}>
                <h6 style={{ 'textAlign':'center', 'marginBottom': '1px'}}>ATTENTION</h6>
                <p className="text-center font-italic">
                    Passé ce délai, aucune garantie au maintien des règles d’urbanisme indiquées dans le certificat ne vous est assurée. Il appartient au
                    demandeur de s’assurer, préalablement à l’acquisition d’une construction, qu’aucune décision de justice n’a ordonné la démolition de cette
                    construction (Greffe des tribunaux de Grande Instance, Notaires, ...).
                </p>
            </div>
            <div className="col-12 text-center  font-weight-lighter" style={{"textAlign":"center", "fontSize":"6pt", "color": "#7e8c8d"}}>
                <h5 style={{ 'textAlign':'center', 'marginBottom': '1px'}}>PROLONGATION DE VALIDITÉ</h5>
                <p style={{'textAlign':'center'}} className={'font-italic'}>
                    Conformément à l’article R 410-17 du Code de l’Urbanisme, le certificat d’urbanisme peut être prorogé par périodes d’une année sur
                    demande présentée deux mois au moins avant l’expiration du délai de validité si les prescriptions d’urbanisme, les servitudes
                    administratives de tous ordres et le régime des taxes et participations d’urbanisme applicables au terrain n’ont pas changé.
                    La demande de prorogation, formulée en double exemplaire, par lettre accompagnée du certificat à proroger, est déposée et transmise
                    dans les conditions prévues à l’article R 410-3 du Code de l’Urbanisme.
                </p>
            </div>

            <div className="col-12 text-center  font-weight-lighter" style={{"textAlign":"center", "fontSize":"6pt", "color": "#7e8c8d"}}>
                <h5 style={{ 'textAlign':'center', 'marginBottom': '1px'}}>RECOURS OBLIGATOIRE À UN ARCHITECTE</h5>
                <p>(Art L 431-1 et suivants et R 431-1 du Code de l'Urbanisme)</p>
                <p style={{'textAlign':'center'}} className={'font-italic'}>
                    L'établissement du projet architectural par un architecte est obligatoire pour toutes constructions.
                    Toutefois, ne sont pas tenues de recourir à un architecte, les personnes physiques ou exploitations agricoles à responsabilité limitée à
                    associé unique qui déclarent vouloir édifier ou modifier, pour elles-mêmes, une construction, à usage autre agricole dont la surface de
                    plancher n'excède pas 150 m².
                    (Pour les constructions à usage agricole, ce plafond est porté à 800 m², et pour les serres de production dont le pied-droit a une hauteur à 4
                    mètres et dont la surface de plancher n’excède pas 2000 m²).
                    <br/>
                    Le recours à l’architecte n’est pas non plus obligatoire pour les travaux soumis au permis de construire qui portent exclusivement sur
                    l’aménagement et l’équipement des espaces intérieurs des constructions et des vitrines commerciales ou qui sont limités à des reprises
                    n’entraînant pas de modifications visibles de l’extérieur (article L 431-3 al 2).
                </p>
            </div>
            <div className="col-12 text-center  font-weight-lighter" style={{"textAlign":"center", "fontSize":"6pt", "color": "#7e8c8d"}}>
                <h5 style={{ 'textAlign':'center', 'marginBottom': '1px'}}>DÉLAIS ET VOIES DE RECOURS</h5>
                <p style={{'textAlign':'center'}} className={'font-italic'}>
                    Le destinataire d'un certificat d'urbanisme qui en conteste le contenu peut saisir le tribunal administratif compétent d'un recours
                    contentieux dans les DEUX MOIS à partir de la notification du certificat. Il peut également saisir d'un recours gracieux l'auteur de la
                    décision ou saisir d'un recours hiérarchique le Ministre chargé de l'urbanisme lorsque le certificat est délivré par le Préfet.
                    Cette démarche prolonge le délai du recours contentieux qui doit alors être introduit dans les deux mois suivant la réponse (l'absence de
                    réponse au terme d'un délai de quatre mois vaut rejet implicite).
                </p>
            </div>












        </div>
    );
};

export default Template2Mentions;
